import { toSafeWhitespaceString as toSafeString } from '@shared/utils';
import resolveMainThreadHeaderRouteContext from '@/lib/routes/resolveMainThreadHeaderRouteContext.js';
import { AUTOMATION_THREAD_BREADCRUMB_META, buildAutomationsViewPath } from '@/lib/automations/automationRoutes.js';
import { pathname, activeAutomationsPane } from '@/redux/selectors/uiSelectors.js';
import { isDraftThreadActive } from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';
import { activeThreadId } from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import { threadMeta } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';
import { routeThreadId } from '@/redux/selectors/pieveSelectors/routeSelectors.js';
import { currentAutomationSchedule } from '@/redux/selectors/pieveSelectors/automationScheduleSelectors.js';
import { currentAutomationTrigger } from '@/redux/selectors/pieveSelectors/automationTriggerSelectors.js';
import { currentWorkflow } from '@/redux/selectors/pieveSelectors/automationWorkflowSelectors.js';
import { automationBreadcrumbType } from '@/redux/selectors/surfaces/threadSurfaceSelectors/automationBreadcrumbType.js';
import { automationRouteFallbackTitle } from '@/redux/selectors/surfaces/threadSurfaceSelectors/automationRouteFallbackTitle.js';

export const automationBreadcrumb = (state) => {
  const type = automationBreadcrumbType(state);
  const meta = AUTOMATION_THREAD_BREADCRUMB_META[type] || null;

  if (!meta) {
    return null;
  }

  const currentActiveThreadId = activeThreadId(state);
  const currentRouteThreadId = isDraftThreadActive(state) ? '' : toSafeString(routeThreadId(state));
  const routeContext = resolveMainThreadHeaderRouteContext({ activeAutomationsPane: activeAutomationsPane(state), pathname: pathname(state) });
  // The Automate workflow thread route carries a thread id, not an automation id, so it names no
  // detail page of its own; the workflow's id comes from the record, as it does on `/threads`.
  const automationRouteId = routeContext?.automationsRouteContext?.isConversation ? '' : toSafeString(routeContext?.automationsRouteContext?.id);
  const selectedWorkflow = currentWorkflow(state);

  const typeLabel = type === 'schedules' ? toSafeString(currentAutomationSchedule(state)?.title) : type === 'triggers' ? toSafeString(currentAutomationTrigger(state)?.title) : type === 'workflows' ? toSafeString(selectedWorkflow?.name || selectedWorkflow?.title) : '';
  const fallbackTitle = automationRouteFallbackTitle(state) || toSafeString(threadMeta(state, currentRouteThreadId || currentActiveThreadId)?.title) || toSafeString(threadMeta(state, currentActiveThreadId)?.title);
  const currentLabel = typeLabel || fallbackTitle || meta.fallbackTitle;

  const typeId = type === 'schedules' ? toSafeString(currentAutomationSchedule(state)?.id) : type === 'triggers' ? toSafeString(currentAutomationTrigger(state)?.id) : type === 'workflows' ? toSafeString(selectedWorkflow?.id) : '';
  const automationId = automationRouteId || typeId;

  return {
    label: meta.label,
    currentLabel,
    listPath: `/automations?filter=${type}`,
    detailPath: `${buildAutomationsViewPath({ type, id: automationId })}?filter=${type}`
  };
};
